export default __webpack_public_path__ + "static/beam1-c15ce207e07a0d327d9d1b4a0a3b6527.mp4";